module.exports = __webpack_public_path__ + "media/content-creator/travel-2-4d3c689e.png";